import React, { useEffect, useState } from 'react';
import useApp from 'hooks/useApp'
import DetailTip from 'views/mydata/common/DetailTip';
import styles from './index.module.css'

const FamilyResult = () => {

	const App = useApp()
	const [showLayer, setShowLayer] = useState(false)

	const openLayer = () => {
		setShowLayer(true)
	}

	const closeLayer = () => {
		setShowLayer(false)
	}

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="flex_1">
				<div className="shadow">
					<div className="padding">
						<div className={styles.update}>
							2022.01.01 기준<i className="icon icon_update ml_10" />
						</div>
						<div className="flex-justify_between mt_10">
							<div className={styles["l-title"]}>
								김모니님은 <strong>5명</strong>이 함께 사는중
							</div>
							<i className="icon icon_question" onClick={openLayer} />
						</div>

						{/* 생일디데이가 3명 이하일 때 */}
						<div className={`${styles["birth-box"]} mt_30`}>
							<ul className={styles["user-birth"]}>
								<li>
									<div className="flex-align_center">
										<span className={styles["icon-area"]}>
											<i className="icon icon_life icon_life_birth_white mt_0" />
										</span>
										<p>김모니님의 생일</p>
									</div>
									<strong className="text-red">D-8</strong>
								</li>
								<li>
									<div className="flex-align_center">
										<span className={styles["icon-area"]}>
											<i className="icon icon_life icon_life_birth_white mt_0" />
										</span>
										<p>김김모니님의 생일</p>
									</div>
									<strong className="text-red">D-9</strong>
								</li>
							</ul>
						</div>

						{/* 생일디데이가 3명 초과일 때 */}
						<div className={`${styles["birth-box"]} mt_30`}>
							<div className="slider">
								<ul>
									<li>
										<ul className={styles["user-birth"]}>
											<li>
												<div className="flex-align_center">
													<span className={styles["icon-area"]}>
														<i className="icon icon_life icon_life_birth_white mt_0" />
													</span>
													<p>김모니님의 생일</p>
												</div>
												<strong className="text-red">D-8</strong>
											</li>
											<li>
												<div className="flex-align_center">
													<span className={styles["icon-area"]}>
														<i className="icon icon_life icon_life_birth_white mt_0" />
													</span>
													<p>김김모니님의 생일</p>
												</div>
												<strong className="text-red">D-9</strong>
											</li>
											<li>
												<div className="flex-align_center">
													<span className={styles["icon-area"]}>
														<i className="icon icon_life icon_life_birth_white mt_0" />
													</span>
													<p>김김모니님의 생일</p>
												</div>
												<strong className="text-red">D-9</strong>
											</li>
										</ul>
									</li>
								</ul>
								<ul className="slider-dots slider-dots__red dots-gray mt_15">
									<li className="active" />
									<li />
									<li />
								</ul>
							</div>
						</div>
					</div>
				</div>
				<div className="padding">
					<h3>패밀리정보</h3>
					<div className={styles["family-box"]}>
						<div className={styles["user-name"]}>
							<div className="flex-align_center">김모니 <i className="tag tag-round tag-blue ml_5">MY</i></div>
							<span className="ml_5">세대주</span>
						</div>
						<ul className={`${styles["user-info"]} mt_20`}>
							<li>
								<div className="flex-align_start">
									<i className="icon icon_life icon_life_birth mr_5" />
									<span>1993.01.01 (만 28세)</span>
								</div>
								<i className="tag tag-box tag-gray-line">D-50</i>
							</li>
							<li>
								<div className="flex-align_start">
									<i className="icon icon_life icon_life_zodiac09 mr_5" />
									<span>원숭이띠</span>
								</div>
							</li>
							<li>
								<div className="flex-align_start">
									<i className="icon_life icon_life_wedding icon mr_5" />
									<span>배우자 김머니</span>
								</div>
							</li>
							<li>
								<div className="flex-align_start">
									<i className="icon_life icon_life_place icon mr_5" />
									<span>서울시 영등포구 여의대로 24, 43층(여의도동, 전경련회관)</span>
								</div>
							</li>
						</ul>
						<div className={`${styles["detail-box"]} mt_20 mb_0`}>
							<ul className="list-item" style={{ fontSize: "1.2rem" }}>
								<li>
									<span>세대구성일</span>
									<span>1999.02.02</span>
								</li>
								<li>
									<span>구성사유</span>
									<span>전입</span>
								</li>
								<li>
									<span>등록상태</span>
									<span>거주자</span>
								</li>
							</ul>
						</div>
					</div>
					<div className={styles["family-box"]}>
						<div className={styles["user-name"]}>김머니</div>
						<ul className={`${styles["user-info"]} mt_20`}>
							<li>
								<div className="flex-align_start">
									<i className="icon_life icon_life_birth icon mr_5" />
									<span>1994.01.01 (만 27세)</span>
								</div>
								<i className="tag tag-box tag-red-line">D-9</i>
							</li>
							<li>
								<div className="flex-align_start">
									<i className="icon_life icon_life_zodiac11 icon mr_5" />
									<span>개띠</span>
								</div>
							</li>
							<li>
								<div className="flex-align_start">
									<i className="icon_life icon_life_wedding icon mr_5" />
									<span>배우자 김모니</span>
								</div>
							</li>
						</ul>
						<div className={`${styles["detail-box"]} mt_20 mb_0`}>
							<ul className="list-item" style={{ fontSize: "1.2rem" }}>
								<li>
									<span>세대주와의 관계</span>
									<span>배우자</span>
								</li>
								<li>
									<span>세대편입일</span>
									<span>1999.02.02</span>
								</li>
								<li>
									<span>변동일</span>
									<span>1999.02.02</span>
								</li>
								<li>
									<span>변동사유</span>
									<span>전입</span>
								</li>
								<li>
									<span>등록상태</span>
									<span>거주자</span>
								</li>
							</ul>
						</div>
					</div>
					<div className={styles["family-box"]}>
						<div className={styles["user-name"]}>김김모니</div>
						<ul className={`${styles["user-info"]} mt_20`}>
							<li>
								<div className="flex-align_start">
									<i className="icon_life icon_life_birth icon mr_5" />
									<span>1994.01.01 (만 27세)</span>
								</div>
								<i className="tag tag-box tag-red-line">D-9</i>
							</li>
							<li>
								<div className="flex-align_start">
									<i className="icon_life icon_life_zodiac11 icon mr_5" />
									<span>개띠</span>
								</div>
							</li>
						</ul>
						<div className={`${styles["detail-box"]} mt_20 mb_0`}>
							<ul className="list-item" style={{ fontSize: "1.2rem" }}>
								<li>
									<span>세대주와의 관계</span>
									<span>자녀</span>
								</li>
								<li>
									<span>세대편입일</span>
									<span>1999.02.02</span>
								</li>
								<li>
									<span>변동일</span>
									<span>1999.02.02</span>
								</li>
								<li>
									<span>변동사유</span>
									<span>전입</span>
								</li>
								<li>
									<span>등록상태</span>
									<span>거주자</span>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
			<div className="flex-shrink_0 padding">
				<div className={`${styles["life-guide-banner"]} ${styles["life-banner02"]}`}>
					<div className="pl_90">
						<span>집 근처 보육 및 교육시설이 궁금하다면?</span>
						<p className="mt_5">어린이집부터 유치원,<br />초・중・고등학교까지 조회해보세요!</p>
					</div>
					<div className={styles.object} />
				</div>
			</div>

			<DetailTip show={showLayer} closeLayer={closeLayer} content="모니에서는 주민등록등본 상 거주지에 함께 거주중인 가족의 정보를 제공해요." title="가족 정보가 다르게 나오나요?" />
		</div>
	)
}

export default FamilyResult